import countryList from '@/locales/country-list.json'
// export default (originalPrice, discountedPrice) => Math.round((100 * (originalPrice - discountedPrice) / originalPrice) * 10) / 10;
const countryByAbbreviation = (abb) => {
  return countryList.find(country => country.abbreviation === abb)
}

export default countryByAbbreviation